import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "semantic-ui-react";
import Navbarside from "../component/Navbarside";
import { Link } from "react-router-dom";
import { GetHotels } from "../store/slices/Hotels";
import Footer from "./footer";

const Hotels = () => {
  const [expertises, setexpertise] = useState([]);
  const { loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(GetHotels())
      .unwrap()
      .then((data) => {
        setexpertise(data.user.data);
      })
      .catch(({ message }) => {
        alert(message);
      });
  }, [dispatch]);
  return (
    <div>
      <Navbarside />

      <div className="container-fluid response-cover">
        <div className="row">
          <div className="col-lg-2 col-md-4" />
          <div className="col-lg-10 col-md-8">
            <div className="container-fluid pt-5">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title-wrap bar-success">
                        <h4 className="card-title">
                          Hotels &nbsp; &nbsp;
                          <Link to="/Addhotels" className="btn btn-primary">
                            <i className="fa fa-plus"></i> Add
                          </Link>
                        </h4>
                      </div>
                    </div>
                    <div className="card-body collapse show">
                      <div className="card-block card-dashboard table-responsive">
                        <table className="table table-striped table-bordered zero-configuration">
                          <thead>
                            <tr>
                              <th>Hotel Name</th>
                              <th>Address</th>

                              <th>Status</th>
                              <th>Rooms</th>
                              <th>Add Image</th>
                              <th>Action</th>
                            </tr>
                          </thead>

                          {loading ? (
                            <Loader active inline />
                          ) : (
                            <>
                              <tbody>
                                {expertises.map((hotlsVal, index) => (
                                  <tr key={index}>
                                    <td>{hotlsVal.name}</td>
                                    <td
                                      style={{
                                        width: "250px",
                                      }}
                                    >
                                      {hotlsVal.address.buildingName},
                                      {hotlsVal.address.street}
                                      <br />
                                      {hotlsVal.address.city.name},
                                      {hotlsVal.address.state.name} -{" "}
                                      {hotlsVal.address.zipCode}
                                    </td>

                                    <td>
                                      {hotlsVal.isApproved === false && (
                                        <button
                                          className="btn btn-danger"
                                          style={{
                                            height: "25px",
                                            padding: "0 10px",
                                          }}
                                        >
                                          Pending
                                        </button>
                                      )}
                                      {hotlsVal.isApproved === true && (
                                        <button
                                          className="btn btn-success"
                                          style={{
                                            height: "25px",
                                            padding: "0 10px",
                                          }}
                                        >
                                          Approved
                                        </button>
                                      )}
                                    </td>
                                    <td>
                                      <Link
                                        className="btn btn-primary"
                                        style={{
                                          height: "25px",
                                          padding: "0 10px",
                                        }}
                                        to={`/AddRoom/${
                                          hotlsVal._id ? hotlsVal._id : null
                                        }`}
                                      >
                                        Add Rooms
                                      </Link>{" "}
                                      &nbsp;{" "}
                                      <Link
                                        className="btn btn-success"
                                        style={{
                                          height: "25px",
                                          padding: "0 10px",
                                        }}
                                        to={`/AddRoom/${
                                          hotlsVal._id ? hotlsVal._id : null
                                        }`}
                                      >
                                        View Rooms
                                      </Link>
                                    </td>
                                    <td>
                                      <Link
                                        className="btn btn-danger"
                                        style={{
                                          height: "25px",
                                          padding: "0 10px",
                                        }}
                                        to={`/AddImage/${
                                          hotlsVal._id ? hotlsVal._id : null
                                        }`}
                                      >
                                        Add Image
                                      </Link>
                                    </td>
                                    <td>
                                      <Link
                                        className="btn btn-primary"
                                        style={{
                                          height: "25px",
                                          padding: "0 10px",
                                        }}
                                        to={`/AddRoom/${
                                          hotlsVal._id ? hotlsVal._id : null
                                        }`}
                                      >
                                        Edit
                                      </Link>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </>
                          )}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Hotels;
